import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import {
  MobileCart,
  MobileMenuDrawer,
  MobileProfile,
  MobileSearch,
  MobileCitySelect,
} from "./MobileHeaderComponents";
import mobileHeaderStyles from "./MobileHeader.module.css";

const Mobileheader = () => {
  const [openMenuDrawer, setOpenMenuDrawer] = useState(false);

  return (
    <>
      <div className={mobileHeaderStyles.mobileheader}>
        <div className={mobileHeaderStyles.topheader}>
          <div className={mobileHeaderStyles.leftSideHeader}>
            <div
              className={mobileHeaderStyles.iconContainer}
              onClick={() => setOpenMenuDrawer(true)}
            >
              <MenuIcon className={mobileHeaderStyles.menuIcon} />
            </div>
            {/* <Link href="\imaging"> */}
            <Link to={"/imaging"} className={mobileHeaderStyles.logoAnchor}>
              <img
                // className={mobileHeaderStyles.logo}
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e297bdda-8a10-4cf2-b567-c0d2d911e32c.webp"
                alt="logo"
                width={110}
                height={35}
                style={{ imageRendering: "-webkit-optimize-contrast" }}
              />
            </Link>
            {/* </Link> */}
          </div>
          <div
            className={mobileHeaderStyles.rightSideHeader}
            style={{ justifyContent: "flex-end" }}
          >
            {/* CART */}
            {/* <MobileCart /> */}

            {/* PROFILE */}
            <MobileProfile />
          </div>
        </div>
        <div className={mobileHeaderStyles.bottomHeader}>
          <MobileSearch />
          <MobileCitySelect />
        </div>
      </div>
      {openMenuDrawer ? (
        <MobileMenuDrawer setOpenMobileMenuDrawer={setOpenMenuDrawer} />
      ) : null}
    </>
  );
};

export default Mobileheader;
